<template>
  <div v-if="!tokenExpire">
    <div
      class="intro-y flex flex-col lg:flex-row justify-between lg:items-end gap-0 lg:gap-2 mt-8"
    >
      <div class="flex flex-row items-end">
        <div
          class="bg-green-600 px-8 py-2 lg:text-2xl font-bold text-white text-center rounded-md"
        >
          OF
        </div>
        <h2 class="text-lg font-medium ml-4">รายละเอียด {{ of.of_no }}</h2>
      </div>
    </div>
    <div class="grid grid-cols-12 gap-6 mt-0 lg:mt-5">
      <div class="intro-y col-span-12">
        <div class="mt-5">
          <div class="h-10 w-full text-center my-20" v-if="loadingPage">
            <LoadingIcon icon="oval" class="w-12 h-12" />
          </div>
          <div class="horizontal-form" v-else>
            <div class="mb-4" v-if="isApprove">
              <ApproveOF
                form-page="approve"
                :of-id="of.of_id"
                :activity="of.activity_list"
                :employee-id="of.claim_id"
                :token="token"
                :show="of.is_approve_token_used == 0"
                :edit="of.flag_edit == 1"
                :approver-info="of.approver_info"
                @reload="reloadOF"
              />
            </div>
            <div class="mb-4">
              <DocumentPath
                :document-path="of.document_path_array"
                :status-code="of.status_code"
                :flag-edit="of.flag_edit"
                :next-status-code="of.next_status"
                :approve-result="of.approve_result_array"
              />
            </div>
            <HeaderCompany
              :img-logo="of.of_comp.comp_logo"
              :status-name="of.status_name"
              :participants="of.participants"
              :document-path="of.document_path_text_array"
            />
            <div class="mt-5">
              <TableSummaryCost :items="of.itemSummary" />
            </div>
            <div class="box intro-y mt-5 p-5">
              <HeaderOwner
                :reqName="of.req_name"
                :companyName="of.of_comp.comp_name_th"
                :buNo="of.bu_no"
                :buName="of.bu_name"
                :telephone="of.telephone"
              />
            </div>
            <div
              class="flex flex-col-reverse lg:flex-none lg:grid lg:grid-cols-3 mt-5 gap-4"
            >
              <div class="box intro-y p-5 col-span-2">
                <div class="font-bold text-lg">ข้อมูลการขอซื้อ</div>
                <div class="grid grid-cols-1 lg:grid-cols-4 lg:gap-4">
                  <div class="col-span-3">
                    <!-- สกุลเงิน -->
                    <div class="flex flex-row lg:flex-col justify-between mt-4">
                      <label class="form-label font-bold">สกุลเงิน:</label>
                      <div>{{ of.currency }}</div>
                    </div>
                    <div class="flex flex-row lg:flex-col justify-between mt-4">
                      <label class="form-label font-bold"
                        >ชนิดของการซื้อ:</label
                      >
                      <div>{{ of.orderTypeText }}</div>
                    </div>
                    <!-- รายละเอียด -->
                    <div class="mt-4">
                      <label class="form-label font-bold">รายละเอียด:</label>
                      <div
                        class="overflow-x-auto"
                        v-html="
                          of.req_detail
                            ? of.req_detail.replaceAll('\n', '<br />')
                            : ''
                        "
                      ></div>
                    </div>
                  </div>

                  <div>
                    <!-- เอกสารจาก Memo -->
                    <div class="mt-4">
                      <label for="" class="form-label font-bold"
                        >เอกสารจาก Memo:</label
                      >
                      <div>
                        <a
                          :href="of.ememo_link"
                          class="text-blue-400"
                          target="_blank"
                          >{{ of.ememo_title }}</a
                        >
                      </div>
                    </div>
                    <!-- ไฟล์แนบ -->
                    <div class="mt-4 col-span-1">
                      <label class="form-label font-bold">ไฟล์แนบ:</label>
                      <AttachFilePreview :data="of.file_attach_array" />
                    </div>
                  </div>
                </div>
              </div>

              <div class="box intro-y p-5">
                <div class="font-bold text-lg">ข้อมูลด้านบัญชี</div>
                <GLDate
                  class="mt-5"
                  url="preorder/of/updateOfGldate"
                  :id="of.of_id"
                  :glDate="of.glDate"
                  :isPermissionVat="of.is_permission_vat"
                  :isApprove="isApprove"
                  :isClaim="isClaim"
                />
              </div>
            </div>

            <div class="mt-5 gap-4">
              <div class="intro-y box p-5 space-y-4">
                <div class="text-lg font-bold">รายการเบิก</div>
                <TableItemOF
                  :items="of.items"
                  :is-permission-vat="of.is_permission_vat"
                  :is-approve="isApprove"
                  :is-claim="isClaim"
                  :is-update-material="isUpdateMaterial"
                  page="approve"
                />
              </div>
            </div>

            <div class="mt-5">
              <TableHistory :items="of.historyArray" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <TryLogin :tokenExpireText="tokenExpireText" />
  </div>
  <Notification />
</template>

<script lang="ts">
import {
  defineComponent,
  computed,
  reactive,
  onMounted,
  ref,
  onUnmounted
} from 'vue'
import { useStore } from '@/store'
import { useRoute } from 'vue-router'
import { api } from '../../../utils/api'
import alert from '../../../helpers/alert'
import helpers from '../../../helpers'
import ApproveOF from '@/components/approve-of/Main.vue'
import DocumentPath from '@/components/document-path/Main.vue'
import TableSummaryCost from '@/components/TableSummaryCost.vue'
import TableHistory from '@/components/TableHistory.vue'
import AttachFilePreview from '@/components/attach-file/Preview.vue'
import TableItemOF from '@/components/TableItemOF.vue'
import Notification from '@/components/notification/Notification.vue'
import TryLogin from '@/components/TryLogin.vue'
import HeaderCompany from '@/components/HeaderCompany.vue'
import HeaderOwner from '@/components/HeaderOwner.vue'
import GLDate from '@/components/GLDate.vue'
export default defineComponent({
  components: {
    ApproveOF,
    DocumentPath,
    TableSummaryCost,
    AttachFilePreview,
    TableHistory,
    TableItemOF,
    Notification,
    TryLogin,
    HeaderCompany,
    HeaderOwner,
    GLDate
  },
  setup() {
    const store = useStore()
    const route = useRoute()
    const loadingPage = computed(() => store.state.global.loadingPage)
    const btnReject = computed(() => store.state.of.btnReject)

    // const userInfo = computed(() => store.state.auth.info)
    const { numberFormat, dateFormat } = helpers

    const tokenExpire = ref(false)
    const tokenExpireText = ref('')
    const token = ref(route.query.token)
    const isOwner = ref(false)
    const isApprove = ref(false)
    const isUpdateMaterial = ref(false)

    const of = reactive({
      owner_name: '',
      of_no: '',
      status_code: null,
      next_status: null,
      of_id: null,
      claim_id: '',
      glDate: '',
      activity_list: [],
      document_path_text_array: [],
      document_path_array: [],
      approve_result_array: [],
      of_comp: {
        comp_name_th: '',
        comp_logo: ''
      },
      telephone: '',
      bu_no: '',
      bu_name: '',
      currency: '',
      req_name: '',
      req_detail: '',
      ememo_id: '',
      ememo_title: '',
      ememo_link: '',
      flag_edit: 0,
      file_attach_array: [],
      items: [],
      itemSummary: [],
      historyArray: [],
      is_approve_token_used: 0,
      status_name: '',
      participants: '',
      approver_info: {},
      orderTypeText: '',
      vendorCode: '',
      vendorName: '',
      vendorEamil: '',
      vendorTelephone: '',
      // poDocTypeText: '',
      // reasonChosenVendor: '',
      // notePurchase: '',
      is_permission_vat: false
    })

    // const formOF = reactive({
    //   vendorSelected: null,
    //   vendorCode: '',
    //   vendorName: '',
    //   vendorAddress: '',
    //   reasonChosenVendor: '',
    //   poDocType: 'P',
    //   notePurchase: '',
    //   notePurchaseDisplay: false
    // })

    const reloadOF = () => {
      loadOF()
    }

    const isClaim = computed(() => store.state.of.isClaim)

    const loadOF = async () => {
      if (route.query.token) {
        await api
          .get(
            `${process.env.VUE_APP_API_URL}/preorder/of/getByToken/${route.query.token}`
          )
          .then(res => {
            if (res.code == 200) {
              of.of_id = res.data.of_id
              of.activity_list = res.data.allow_list_array
                ? res.data.allow_list_array.activity_list
                : []
              of.owner_name = res.data.owner_name
              of.of_no = res.data.doc_no_full
              of.claim_id = res.data.claim_id
              of.is_approve_token_used = res.data.is_approve_token_used
              of.status_code = res.data.status_code
              of.next_status = res.data.next_status
              of.document_path_text_array = res.data.document_path_text_array
              of.document_path_array = res.data.document_path_array
              of.approve_result_array = res.data.approve_result_array
              of.req_name = res.data.req_name
              of.telephone = res.data.telephone
              of.bu_no = res.data.bu_no
              of.bu_name = res.data.bu_name
              of.currency = res.data.currency_code
              of.req_detail = res.data.req_detail
              of.items = res.data.items
              of.flag_edit = res.data.flag_edit
              of.status_name = res.data.status_name
              of.participants = res.data.participants
              of.itemSummary = res.data.itemSummary
              of.historyArray = res.data.history_array
              of.approver_info = res.data.approver_info
              of.orderTypeText = res.data.order_type_text
              of.glDate = res.data.gl_date
              of.is_permission_vat = res.data.is_permission_vat != 0

              // of.notePurchase =
              //   res.data.note_purchase !== null
              //     ? res.data.note_purchase
              //     : 'ไม่พบข้อมูล'

              // formOF.notePurchaseDisplay = res.data.is_permission_purchase == 1

              of.ememo_id = res.data.ememo_id
              of.ememo_title = res.data.ememo_title
              of.ememo_link = `${process.env.VUE_APP_BASE_URL}/memo/myActivities/form/${res.data.ememo_id}/detail`
              of.file_attach_array = res.data.file_attach_array

              // of.vendorCode = res.data.vendor_code
              // of.vendorName = res.data.vendor_name
              // of.vendorEamil = res.data.vendor_email
              // of.vendorTelephone = res.data.vendor_telephone
              // of.poDocTypeText = res.data.po_doc_type_text
              // of.reasonChosenVendor = res.data.reason_chosen_vendor

              of.of_comp = store.getters['global/companyFind'](res.data.of_comp)

              // if (userInfo.value.employeeId == res.data.owner_id) {
              //   isOwner.value = true
              //   if (
              //     res.data.is_editing != 1 &&
              //     res.data.status_code == 'CMD_REVIEW'
              //   ) {
              //     store.commit('of/setBtn', {
              //       type: 'btnReject',s
              //       value: 'hide'
              //     })
              //   }
              // } else {
              //   isApprove.value = false
              //   if (res.data.allow_list_array) {
              //     res.data.allow_list_array.activity_list.map(item => {
              //       if (item.employee_id == userInfo.value.employeeId) {
              //         isApprove.value = true
              //       }
              //     })
              //   }
              // }

              isApprove.value = false
              if (res.data.allow_list_array && res.data.approver_info) {
                res.data.allow_list_array.activity_list.map(item => {
                  // if (item.employee_id == res.data.claim_id) {
                  if (item.employee_id == res.data.approver_info.employee_id) {
                    isApprove.value = true
                  }
                })
                // if (res.data.claim_id === null) {
                //   isApprove.value = true
                // }
              }

              store.commit(
                'of/setIsClaim',
                res.data.claim_id === null && isApprove.value
              )

              store.commit('global/setOverBudget', {
                message:
                  res.data.is_over_budget == 1
                    ? 'เกินงบประมาณ'
                    : 'อยู่ในงบประมาณ',
                isOver: res.data.is_over_budget == 1,
                show: true
              })
            } else {
              tokenExpire.value = true
              tokenExpireText.value = res.validator.approve_token[0]
            }
          })
          .catch(e => {
            alert.error(e.message)
            // console.log('error: ', e)
            tokenExpire.value = true
          })
      }
    }

    onUnmounted(() => {
      console.log('unmounted page of detail')
      store.commit('of/initBtn')
      isOwner.value = false
      isApprove.value = false
    })

    onMounted(async () => {
      console.log('mounted page of detail')
      await store.dispatch('global/loadCompanyToken')
      await store.dispatch('global/loadCash')
      await loadOF()
      store.commit('global/setLoadingPage', false)
    })

    return {
      btnReject,
      of,
      reloadOF,
      loadingPage,
      numberFormat,
      dateFormat,
      isOwner,
      isApprove,
      isClaim,
      tokenExpire,
      tokenExpireText,
      token,
      isUpdateMaterial
      // formOF
      // saveNotePurchase
    }
  }
})
</script>

<style scoped></style>
